<template>
  <div class="love-pk-list">
    <el-card shadow="hover">
      <template #header>
        <div class="card-header">
          <span>Love PK管理</span>
        </div>
      </template>
        <el-table :data="lovePkList" style="width: 100%">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="theme" label="标题"></el-table-column>
        <el-table-column prop="date" label="日期" width="120"></el-table-column>
        <el-table-column prop="total_votes" label="总投票数" width="120"></el-table-column>
        <el-table-column label="①旁路转推" width="150">
          <template #default="scope">
            <div class="fee-cell">
              <el-tag
                v-if="scope.row.streaming_out_status === 'active'"
                type="danger" effect="light" size="mini"
              >计费中</el-tag>
              <el-tag
                v-else-if="scope.row.streaming_out_status === 'idle'"
                type="info" effect="plain" size="mini"
              >已暂停</el-tag>
              <el-tag v-else type="success" effect="plain" size="mini">未启动</el-tag>
              <span class="fee-num">¥{{ fmtFee(scope.row.cost_relay) }}</span>
              <span v-if="scope.row.streaming_out_minutes > 0" class="fee-sub">
                ({{ scope.row.streaming_out_minutes }}min)
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="②CDN RTS流量" width="130">
          <template #default="scope">
            <div class="fee-cell">
              <span class="fee-num">¥{{ fmtFee(scope.row.cost_cdn) }}</span>
              <span class="fee-sub">({{ fmtGb(scope.row.cdn_traffic_gb) }} GB)</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="③RTC通信" width="110">
          <template #default="scope">
            <div class="fee-cell">
              <span class="fee-num">¥{{ fmtFee(scope.row.cost_rtc) }}</span>
              <span class="fee-sub" v-if="scope.row.cost_rtc > 0">上麦中</span>
              <span class="fee-sub" v-else>&nbsp;</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="④直播转码" width="110">
          <template #default="scope">
            <div class="fee-cell">
              <span class="fee-num">¥{{ fmtFee(scope.row.cost_transcode) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="合计" width="110">
          <template #default="scope">
            <div class="fee-cell fee-total">
              <span class="fee-num">¥{{ fmtFee(scope.row.cost_total) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template #default="scope">
            <el-tag :type="scope.row.status ? 'success' : 'info'">
              {{ scope.row.status ? '进行中' : '已结束' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180">
          <template #default="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template #default="scope">
            <el-button type="primary" size="small" @click="openTalkDialog(scope.row)">
              对话
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>

    <!-- PK对话弹窗 -->
    <el-dialog
      :visible.sync="talkDialogVisible"
      :title="`PK对话 - ${currentPk.theme || ''}`"
      width="720px"
      @close="talkDialogVisible = false"
    >
      <div class="talk-toolbar">
        <div class="talk-toolbar__main">
          <span class="talk-toolbar__label">回合数：</span>
          <el-input-number
            v-model="talkRounds"
            :min="1"
            :max="maxTalkRounds"
            size="small"
            class="talk-toolbar__rounds"
          />
          <el-button
            type="primary"
            size="small"
            :loading="generating"
            @click="generateTalk"
          >
            {{ generating ? '生成中...' : '生成更多对话' }}
          </el-button>
          <el-button size="small" @click="fetchTalkList">刷新</el-button>
          <el-button
            type="danger"
            size="small"
            plain
            :loading="clearing"
            @click="handleClearTalk"
          >
            {{ clearing ? '清除中...' : '清除对话' }}
          </el-button>
          <el-tag type="success" effect="plain" size="medium" class="talk-toolbar__stats">
            共 {{ totalRounds }} 回合{{ talkBatches.length ? `（${talkBatches.length} 批）` : '' }}
          </el-tag>
        </div>
        <div class="talk-toolbar__tip">
          单次最多生成 {{ maxTalkRounds }} 回合，可多次生成、回合号自动接续；清除对话为逻辑删除，清除后重新生成将从第 1 回合开始
        </div>
      </div>

      <div v-loading="talkLoading" class="talk-body">
        <template v-if="talkBatches.length">
          <div
            v-for="(batch, bIdx) in talkBatches"
            :key="batch.batch_id"
            class="talk-batch"
          >
            <div class="talk-batch__header">
              <span>第 {{ talkBatches.length - bIdx }} 批</span>
              <span class="talk-batch__time">{{ formatDate(batch.created_at) }}</span>
            </div>
            <div class="talk-messages">
              <div
                v-for="talk in batch.talks"
                :key="talk.id"
                :class="['talk-msg', talk.speaker == 1 ? 'talk-msg--believe' : 'talk-msg--disbelieve']"
              >
                <div class="talk-msg__speaker">
                  {{ talk.speaker == 1 ? believeLabel : disbelieveLabel }}
                  <span class="talk-msg__round">第{{ talk.round }}回合</span>
                </div>
                <div class="talk-msg__content">{{ talk.content }}</div>
              </div>
            </div>
          </div>
        </template>
        <el-empty v-else description="暂无对话记录，点击「生成更多对话」开始" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'LovePkList',
  data() {
    return {
      lovePkList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,

      // 弹窗相关
      talkDialogVisible: false,
      currentPk: {},
      talkBatches: [],
      talkLoading: false,
      generating: false,
      clearing: false,
      talkRounds: 10,
      // 与后端 LovePkService::MAX_TALK_ROUNDS_HTTP 保持一致：后台是同步请求，回合数过大会被网关超时断掉
      maxTalkRounds: 20
    }
  },
  computed: {
    believeLabel() {
      return this.currentPk.believe_name || '正方'
    },
    disbelieveLabel() {
      return this.currentPk.disbelieve_name || '反方'
    },
    // 总回合数：取所有批次对话中最大的绝对回合号（每回合含正反2条发言，不能用消息条数）
    totalRounds() {
      let maxRound = 0
      this.talkBatches.forEach(batch => {
        (batch.talks || []).forEach(talk => {
          const round = Number(talk.round) || 0
          if (round > maxRound) maxRound = round
        })
      })
      return maxRound
    }
  },
  mounted() {
    this.fetchLovePkList()
    // 每 60 秒刷新一次，旁路费用需要实时更新但又不要频率太高
    this._costTimer = setInterval(() => this.fetchLovePkList(), 60000)
  },
  beforeUnmount() {
    if (this._costTimer) {
      clearInterval(this._costTimer)
      this._costTimer = null
    }
  },
  methods: {
    // 获取Love PK列表
    fetchLovePkList() {
      try {
        const token = localStorage.getItem('adminToken')
        fetch(`/api/admin/content/love-pk-list?page=${this.currentPage}&pageSize=${this.pageSize}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        })
        .then(response => response.json())
        .then(data => {
          if (data.code === 0) {
            this.lovePkList = data.data.list
            this.total = data.data.total
          }
        })
      } catch (error) {
        this.$message.error('获取Love PK列表失败')
      }
    },

    // 分页
    handleSizeChange(size) {
      this.pageSize = size
      this.fetchLovePkList()
    },

    handleCurrentChange(page) {
      this.currentPage = page
      this.fetchLovePkList()
    },

    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp * 1000)
      return date.toLocaleString('zh-CN')
    },

    // 费用格式化：空/null→0.0000，否则保留4位小数
    fmtFee(v) {
      const n = Number(v)
      if (!isFinite(n)) return '0.0000'
      return n.toFixed(4)
    },

    // GB 格式化：空/null→0.0000，否则保留4位小数
    fmtGb(v) {
      const n = Number(v)
      if (!isFinite(n)) return '0.0000'
      return n.toFixed(4)
    },

    // 打开对话弹窗
    openTalkDialog(row) {
      this.currentPk = row
      this.talkDialogVisible = true
      this.talkBatches = []
      this.fetchTalkList()
    },

    // 获取对话记录
    async fetchTalkList() {
      this.talkLoading = true
      try {
        const token = localStorage.getItem('adminToken')
        const res = await fetch(`/api/admin/content/pk-talk-list?pk_id=${this.currentPk.id}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        })
        const data = await res.json()
        if (data.code === 0) {
          // 最新批次在前
          this.talkBatches = (data.data.batches || []).reverse()
        } else {
          this.$message.error(data.message || '获取对话失败')
        }
      } catch (e) {
        this.$message.error('获取对话记录失败')
      } finally {
        this.talkLoading = false
      }
    },

    // 生成对话
    async generateTalk() {
      this.generating = true
      try {
        const token = localStorage.getItem('adminToken')
        const res = await fetch('/api/admin/content/generate-pk-talk', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            pk_id: this.currentPk.id,
            rounds: this.talkRounds
          })
        })
        const data = await res.json()
        if (data.code === 0) {
          this.$message.success('生成成功')
          // 将新批次插入到列表顶部
          const newBatch = {
            batch_id: data.data.batch_id,
            created_at: Math.floor(Date.now() / 1000),
            talks: data.data.talks || []
          }
          this.talkBatches.unshift(newBatch)
        } else {
          this.$message.error(data.message || '生成失败')
        }
      } catch (e) {
        this.$message.error('生成对话失败')
      } finally {
        this.generating = false
      }
    },

    // 清除对话（逻辑删除）
    handleClearTalk() {
      const theme = this.currentPk.theme || ''
      this.$confirm(`确定要清除「${theme}」的全部对话吗？清除后需重新生成，回合号将从第 1 回合开始。`, '清除对话', {
        confirmButtonText: '确定清除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.clearing = true
        try {
          const token = localStorage.getItem('adminToken')
          const res = await fetch('/api/admin/content/clear-pk-talk', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ pk_id: this.currentPk.id })
          })
          const data = await res.json()
          if (data.code === 0) {
            this.$message.success(`已清除 ${data.data.cleared} 条对话`)
            this.talkBatches = []
          } else {
            this.$message.error(data.message || '清除失败')
          }
        } catch (e) {
          this.$message.error('清除对话失败')
        } finally {
          this.clearing = false
        }
      }).catch(() => {
        // 用户取消
      })
    }
  }
}
</script>

<style scoped>
.love-pk-list {
  width: 100%;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* 直播费用四类分项列 */
.fee-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 1.4;
}
.fee-num {
  font-weight: 600;
  font-size: 13px;
  color: #303133;
  white-space: nowrap;
}
.fee-sub {
  font-size: 12px;
  color: #909399;
  white-space: nowrap;
}
.fee-total .fee-num {
  color: #e6a23c; /* 橙色醒目提示总费用 */
  font-size: 14px;
}

/* 弹窗工具栏 */
.talk-toolbar {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 16px;
}
/* 操作行：控件一行排开，空间不足时整体换行，单个控件不被压缩截断 */
.talk-toolbar__main {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.talk-toolbar__label {
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
  flex-shrink: 0;
}
.talk-toolbar__rounds {
  width: 130px;
  flex-shrink: 0;
}
.talk-toolbar__stats {
  margin-left: auto;
  flex-shrink: 0;
}
.talk-toolbar__tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.6;
}

/* 弹窗内容区 */
.talk-body {
  max-height: 520px;
  overflow-y: auto;
  padding-right: 4px;
}

/* 批次卡片 */
.talk-batch {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  margin-bottom: 16px;
  overflow: hidden;
}
.talk-batch__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 14px;
  background: #f5f7fa;
  font-size: 13px;
  color: #606266;
  border-bottom: 1px solid #ebeef5;
}
.talk-batch__time {
  font-size: 12px;
  color: #909399;
}

/* 消息列表 */
.talk-messages {
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* 单条消息 */
.talk-msg {
  display: flex;
  flex-direction: column;
  max-width: 80%;
  padding: 10px 14px;
  border-radius: 10px;
  font-size: 14px;
  line-height: 1.6;
}
.talk-msg--believe {
  align-self: flex-start;
  background: #ecf5ff;
  border: 1px solid #d9ecff;
}
.talk-msg--disbelieve {
  align-self: flex-end;
  background: #fef0f0;
  border: 1px solid #fde2e2;
}
.talk-msg__speaker {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.talk-msg--believe .talk-msg__speaker {
  color: #409eff;
}
.talk-msg--disbelieve .talk-msg__speaker {
  color: #f56c6c;
}
.talk-msg__round {
  font-size: 11px;
  font-weight: normal;
  color: #909399;
}
.talk-msg__content {
  color: #303133;
  word-break: break-word;
}
</style>
